import { useTranslations } from "next-intl";
import { useState } from "react";
import { useLocalPartnerNameFor } from "@hooks/use-addresses";
import { Button, Image } from "@components/core";
import classNames from "classnames";

const RelayPointCard = ({
  relayPoint,
  selectedRelayPoint,
  setSelectedRelayPoint,
  submitButton = false,
  onSubmit = null,
}) => {
  const t = useTranslations("addresses");

  const localPartnerNameForCountry = useLocalPartnerNameFor(relayPoint.country);
  const localPartnerName = localPartnerNameForCountry(relayPoint.carrier_name);

  const [displayHours, setDisplayHours] = useState(false);

  function handleCardClick() {
    if (selectedRelayPoint?.pickup_id === relayPoint.pickup_id) {
      setSelectedRelayPoint(null);
      return;
    }

    setSelectedRelayPoint(relayPoint);
  }

  function handleDisplayHours(event) {
    event.stopPropagation();
    setDisplayHours(!displayHours);
  }

  function handleSubmit(event) {
    event.stopPropagation();
    if (onSubmit) onSubmit(event);
  }

  function renderOpeningHours(day) {
    const hours = relayPoint.opening_hours[day];

    return (
      <div className="d-flex">
        <p className="relay-points-opening-day">{t(`days_of_week.${day}`)}</p>
        <p className="relay-points-opening-hours">
          {!hours || hours === "closed" ? t("closed") : hours}
        </p>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "btn-transparent relay-points-list-card",
        selectedRelayPoint?.pickup_id === relayPoint.pickup_id && "active",
      )}
      type="button"
      onClick={handleCardClick}
    >
      <div className="d-flex justify-content-between">
        <div>
          <p className="m-0 font-weight-bold">{relayPoint.name}</p>
          <p className="m-0">{relayPoint.line1}</p>
          {relayPoint.line2 && <p className="m-0">{relayPoint.line2}</p>}
          <p className="m-0">
            {relayPoint.zip} {relayPoint.city}, {relayPoint.country}
          </p>
        </div>
        <div className="d-flex flex-column align-items-center font-size-sm gap-1">
          <Image
            src={localPartnerName}
            alt={t("carrier_logo")}
            width={24}
          />
          {Math.round(relayPoint.distance_meters / 10) / 100}
          {t("kilometer_unit")}
        </div>
      </div>

      <div className="mt-2">
        <Button
          variant="link-dark"
          className="no-underline"
          rightIconName="chevron-down"
          onClick={handleDisplayHours}
        >
          {t("see_relay_point_schedule")}
        </Button>
      </div>

      {displayHours && (
        <div className="mt-2 font-size-sm">
          {renderOpeningHours("monday")}
          {renderOpeningHours("tuesday")}
          {renderOpeningHours("wednesday")}
          {renderOpeningHours("thursday")}
          {renderOpeningHours("friday")}
          {renderOpeningHours("saturday")}
          {renderOpeningHours("sunday")}
        </div>
      )}

      {submitButton && selectedRelayPoint?.pickup_id === relayPoint.pickup_id && (
        <Button
          variant="primary"
          className="w-100 mt-3"
          onClick={handleSubmit}
        >
          {t("shipping_form.choose_relay_point")}
        </Button>
      )}
    </div>
  );
};

export default RelayPointCard;
